export default __webpack_public_path__ + "static/media/create-account-liefman.054aa6f8.svg";